<template>
    <MenuBase :hidden="props.hidden"   
        tooltip="Send to team" 
        :tooltipPosition="props.tooltipPosition" 
        :theme="props.theme" 
        :tooltipText="props.tooltipText"
        :active="active"
        @click="sendPlaylistToTeam()" >
        <PaperAirplaneIcon class="size-6" />
    </MenuBase>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
import MenuBase from '@/components/common/menus/MenuBase.vue';
import { PaperAirplaneIcon } from '@heroicons/vue/24/outline';
import { appEvents } from '@/store/app.events';

const emit = defineEmits(['sendPlaylistToTeam'])
const props = defineProps( {
    disabled: {
        type: Boolean,
        default: true
    },
    hidden: {
        type: Boolean,
        default: true
    },
    tooltipPosition: {
        type: String,
        default: 'top',
        validator: (value) => {
            return ['top', 'bottom', 'left', 'right'].includes(value);
        }
    }
})

const sendPlaylistToTeam = () => {
    emit('sendPlaylistToTeam');
    appEvents.emit('sendPlaylistToTeam');
}
</script>
